export const blockIconsPrivacyandsecurityVpnKeyNew = (
	<span className='material-symbols-outlined'>vpn_key</span>
);
